<template>
  <div class="comment__item-task-content">
    <div
      class="comment__audit-compare-content comment__audit-compare-content_vertical comment__task-content-compare"
    >
      <div
        v-if="beforeTask"
        class="comment__item-task is-opacity"
      >
        <div class="comment__item-task__left">
          <span
            class="task-status"
            :class="`task-is-${beforeTask.status.toLowerCase().replace(' ', '_')}`"
            >{{ beforeTask.status }}</span
          >
          <span class="task-name">{{ beforeTask.name }}</span>
        </div>
        <div class="comment__item-task__right">
          <span class="task-type">{{ beforeTask.typeString }}</span>
          <span class="task-estimation">
            <span v-if="beforeTask.isEstimated">{{ beforeTask.estimatedHours }} hr</span>
            <span v-else>{{ $t("none") }}</span>
          </span>
          <div class="task-owner">
            <Avatar
              v-tooltip.bottom="{
                disabled: !beforeTask?.owner,
                content: beforeTask.owner?.username,
                theme: 'info-tooltip-sm'
              }"
              :src="beforeTask?.owner?.picture?.pictureUrl ?? null"
              :gap="beforeTask?.owner?.getInitials()"
              size="md"
              type="avatarGroup"
              :class="[{ 'avatar-select__gap': !beforeTask?.owner }]"
            />
          </div>
        </div>
        <div
          v-if="beforeTask.structuredDescription?.getTextFromHtml"
          class="task-description"
        >
          {{ beforeTask.structuredDescription.getTextFromHtml }}
        </div>
      </div>
      <icon
        v-if="beforeTask"
        data="@icon/arrow-to.svg"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
        color="var(--monochrome05to04)"
        style="transform: rotate(90deg)"
      />
      <div class="comment__item-task">
        <div class="comment__item-task__left">
          <span
            class="task-status"
            :class="`task-is-${afterTask.status.toLowerCase().replace(' ', '_')}`"
            >{{ afterTask.status }}</span
          >
          <span class="task-name">{{ afterTask.name }}</span>
        </div>
        <div class="comment__item-task__right">
          <span class="task-type">{{ afterTask.typeString }}</span>
          <span class="task-estimation">
            <span v-if="afterTask.isEstimated">{{ afterTask.estimatedHours }} hr</span>
            <span v-else>{{ $t("none") }}</span>
          </span>
          <div class="task-owner">
            <Avatar
              v-tooltip.bottom="{
                disabled: !afterTask?.owner,
                content: afterTask.owner?.username,
                theme: 'info-tooltip-sm'
              }"
              :src="afterTask?.owner?.picture?.pictureUrl ?? null"
              :gap="afterTask?.owner?.getInitials()"
              size="md"
              type="avatarGroup"
              class="avatar-select__gap"
              :class="[{ 'avatar-select__gap': !afterTask?.owner }]"
            />
          </div>
        </div>
        <div
          v-if="afterTask.structuredDescription?.getTextFromHtml"
          class="task-description"
        >
          {{ afterTask.structuredDescription.getTextFromHtml }}
        </div>
      </div>
    </div>

    <button
      v-if="
        afterTask.structuredDescription?.html ||
        beforeTask?.structuredDescription?.html ||
        afterTask.spec?.html ||
        beforeTask?.spec?.html
      "
      class="link is-medium comment__view-changes-link"
      @click="toggleViewMore"
    >
      View what was changed
    </button>
    <Teleport to="body">
      <ModalItemTaskChanged :comment="comment" />
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import Avatar from "@/components/Avatar/index.vue"
import ModalItemTaskChanged from "@/components/Modal/ModalItemTaskChanged.vue"

import { Comment, Task } from "@/models"
import { useModal } from "@/plugins/vue-js-modal/index"

const props = defineProps<{
  comment: Comment
}>()

const modal = useModal()
const beforeTask = computed(() =>
  props.comment.itemAuditRecord?.taskBefore
    ? Task.create(props.comment.itemAuditRecord.taskBefore)
    : null
)
const afterTask = computed(() => Task.create(props.comment.itemAuditRecord?.taskAfter))

function toggleViewMore() {
  modal.show(`item-task-changed-${props.comment.id}`)
}
</script>
